import './report-featured-list.scss'

import { pluck, tap } from 'rxjs/operators'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { SearchParams, ReportFeatured, ConditionReport, ConditionReportState } from '@skinsoft/types'
import { conditionReportSelectors } from '@skinsoft/selectors'
import { ConditionReportDataStore } from '@skinsoft/entity'
import { toReportFeaturedFromSearch$ } from '@skinsoft/entity-ui'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC } from '../../../../../apps/condition-report/src/busTopics'
import { ReportfeaturedCard } from '../report-featured-card'
import { TitleClickAction } from '../featured-card'


const REPORT_FEATURED_ITEM_COUNT = 5;

@Component({
    components: {
        sReportFeaturedCard: ReportfeaturedCard
    },
    props: ['listState', 'searchParams', 'emptyMessage', 'titleClickAction'],
    template: require("./report-featured-list.html")
})
export class ReportFeaturedList extends ReactiveVue {
    public listState: ConditionReportState;
    public searchParams: SearchParams;
    public emptyMessage: string;
    private titleClickAction: TitleClickAction

    // the list used to populate UI
    private reportFeatureds: ReportFeatured[] = [];
    // the list used to filter retrieved data 
    private filteredReportFeatured: ReportFeatured[] = [];
    private $conditionReportDataStore: ConditionReportDataStore;

    private totalResults: number = 0;

    private subscribe() {
        const sortObject =
            this.searchParams.sortType === ''
                ? null
                : { entityFields: [this.searchParams.sortType], sortAsc: this.searchParams.sortAsc };


        const advancedSearches = [
            {
                // filtering to keep only reports linked to an item
                leftCriteria: {
                    entityField: "5f32925d9393981d6dd60ebd",
                    operator: "exists",
                    type: "criteria",
                    value: {
                        completeSearch: false,
                        refId: null,
                        type: "ref"
                    },
                },
                linkOperator: "AND",
                // filtering field (on status)
                rightCriteria: {
                    entityField: "5e7b836714256b1944f069fa",
                    operator: "equals",
                    type: "criteria",
                    value: {
                        text: this.listState,
                        type: "text"
                    },
                },
                type: "requestSearch",
            }
        ]

        this.subscribeTo(
            this.$conditionReportDataStore
                .searchAll(
                    {
                        queryText: this.searchParams.queryText,
                        sortObject: sortObject,
                        pageSize: this.searchParams.nbResults,
                        advancedSearches: advancedSearches,
                    }
                )
                .pipe(
                    tap(results => {
                        this.totalResults = results.totalSize
                    }),
                    pluck('allData')
                ),
            (reports: ConditionReport[]) => {
                reports.map(report => {
                    const reportState = conditionReportSelectors.workflowState(report);
                    toReportFeaturedFromSearch$(report, this.$i18n.locale).subscribe(featured => {
                        this.filteredReportFeatured.push(featured)
                    })
                })

                // Retrieving filtered reports to display them
                this.reportFeatureds = this.filteredReportFeatured;
                this.filteredReportFeatured = [];
                this.emitOnBus(NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC, { totalResults: this.totalResults })
            }
            , 'reportFeatureds'
        )
    }

    private unsubscribe() {
        this.unsubscribeFrom('reportFeatureds');
    }

    @Watch('searchParams', { immediate: true, deep: true })
    private onSearchParamsChange() {
        // Testing all search params presence to avoid useless search query during params setting
        if (this.searchParams.nbResults && this.searchParams.sortType) {
            this.unsubscribe();
            this.reportFeatureds = Array(REPORT_FEATURED_ITEM_COUNT).fill(null);
            this.$emit('totalCount', null);
            this.subscribe();
        }
    }

}